import React from 'react'
import { string, bool } from 'prop-types'
import styled from 'styled-components'
import { Heading, Box } from 'rebass'
import { Container } from '../../utils/style'
import typography from '../../utils/typography'

const SectionHeader = styled(({ theme, alignment, relaxed, ...rest }) => (
  <Container {...rest} />
))`
  position: relative;
  text-align: ${(props) => `${props.alignment}`};
  line-height: 1.7;
  max-width: ${(props) => props.theme.content.max.width};

  ${(props) =>
    props.reversed ? 'color:white;' : `color:${props.theme.colors.grey};`}
  a:not(.link) {
    ${(props) =>
      props.reversed ? 'color:white;' : `color:${props.theme.colors.grey};`}
  }
  .link:last-child {
    margin-right: 0;
  }
`

const SectionTitle = styled(Heading)`
  margin-bottom: ${typography.rhythm(0.5)};
  ${(props) => (props.reversed ? 'color:inherit;' : `color:${props.fg};`)}
`

const SectionHeading = styled(Box)`
  text-transform: uppercase;
  font-weight: ${(props) => props.theme.weights[1]};
  color: ${(props) => (props.reversed ? 'white' : props.theme.colors.blue)};
  ${(props) => (props.fg ? `color:${props.fg};` : '')}
`

const ContentSectionHeader = (props) => {
  return (
    <SectionHeader
      mt={[typography.rhythm(1.5), null, typography.rhythm(2)]}
      pt={3}
      pb={[typography.rhythm(1)]}
      alignment={props.alignment}
      reversed={props.reversed}
      relaxed={props.relaxed}
    >
      {props.heading !== '' && (
        <SectionHeading width={12 / 12} reversed={props.reversed}>
          {props.heading}
        </SectionHeading>
      )}
      {props.title !== '' && (
        <SectionTitle
          reversed={props.reversed}
          as="h3"
          fontSize={[6, 7, 8]}
          fg={props.fg}
          id={props.id}
        >
          {props.title}
        </SectionTitle>
      )}
      {props.children}
    </SectionHeader>
  )
}

ContentSectionHeader.defaultProps = {
  heading: '',
  title: '',
  reversed: false,
  alignment: 'center',
  relaxed: false
}
ContentSectionHeader.propTypes = {
  heading: string,
  title: string,
  fg: string,
  reversed: bool,
  alignment: string,
  relaxed: bool,
  id: string
}

export default ContentSectionHeader
